<!-- Contenedor principal con drawer -->
<mat-drawer-container class="shell" autosize>
    <!-- DRAWER IZQUIERDO -->
    <mat-drawer #drawer class="sidesheet" [mode]="drawerMode || 'side'" [opened]="drawerOpened ?? true">

        <!-- Header fijo del drawer -->
        <header class="sidesheet-header">
            <div class="title"></div>
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Cerrar panel" matTooltip="Cerrar panel">
                <mat-icon>close</mat-icon>
            </button>
        </header>

        <!-- Contenido scrolleable del drawer (independiente del contenido principal) -->
        <div class="sidesheet-scroll">
            <ng-container *ngIf="periodosNavBar">
                <nav-bar [navBarItems]="periodosNavBar" [initialValue]="+periodoID" [placeholder]="'Seleccione un año'"
                    [navOnChange]="true" [verticalLayout]="true">
                </nav-bar>
            </ng-container>

            <div class="divider"></div>

            <section class="section">
                <label class="section-title">Vista</label>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedSection"
                    (ngModelChange)="setSelectedSection()" class="radio-stack">
                    <mat-radio-button [value]="1" color="primary">Asistencia</mat-radio-button>
                    <mat-radio-button [value]="2" color="primary">Tareas</mat-radio-button>
                </mat-radio-group>
            </section>

            <div class="divider"></div>

            <section class="section">
                <label class="section-title">Convenciones</label>
                <nivelaciones-convenciones [direccion]="'vertical'" [asistencia]="true" [data]="tiposAsistencia"
                    [dataFilterValues]="['A','A0','A1','A2','A3','R','R0','R1','R2','R3']">
                </nivelaciones-convenciones>
            </section>
        </div>
    </mat-drawer>

    <!-- CONTENIDO PRINCIPAL -->
    <mat-drawer-content class="content">
        <mat-card class="dashboard-card dashboard-fill">
            <div class="topbar">
                <div class="left">
                    <button mat-icon-button class="toggle-drawer" (click)="drawer.toggle()" aria-label="Abrir panel" matTooltip="Abrir panel">
                        <mat-icon>menu</mat-icon>
                    </button>
                    <span class="topbar-title">Asistencia y Tareas</span>
                </div>
            </div>

            <main class="main">
                <header class="toolbar">
                    <div class="filter-row">
                        <mat-form-field appearance="outline" class="field">
                            <mat-label>Filtrar por nombre</mat-label>
                            <input matInput (keyup)="filtroTexto($event.target.value)" autocomplete="off" />
                        </mat-form-field>

                        <span class="spacer"></span>

                        <div class="view-toggle">
                            <span class="muted">Ver valores como:</span>
                            <div class="segmented">
                                <button mat-button class="segmented-item" [class.active]="viewMode !== 'numbers'"
                                    (click)="changeViewMode('percentage')">Porcentaje</button>
                                <button mat-button class="segmented-item" [class.active]="viewMode === 'numbers'"
                                    (click)="changeViewMode('numbers')">Numérico</button>
                            </div>
                        </div>
                    </div>

                    <div class="hint muted">Desplace la tabla hacia la izquierda para ver todos los datos.</div>
                </header>

                <section class="table-wrap mat-elevation-z2" *ngIf="dataSource; else loading" role="region"
                    aria-label="Tabla de asistencia">
                    <div class="scroll-shadow left"></div>
                    <div class="scroll-shadow right"></div>

                    <div class="table-container">
                        <table mat-table #table [dataSource]="dataSource" matSort class="data-lista">
                            <ng-container *ngFor="let column of displayedColumns">
                                <ng-container *ngIf="column === 'Alumno'" matColumnDef="{{column}}" sticky>
                                    <th mat-header-cell *matHeaderCellDef class="col-alumno">{{ column }}</th>
                                    <td mat-cell *matCellDef="let element" class="col-alumno">
                                        <strong class="nombre">{{ element.apellidosNombres }}</strong>
                                    </td>
                                </ng-container>

                                <ng-container *ngIf="column === 'end'" matColumnDef="{{column}}" stickyEnd>
                                    <th mat-header-cell *matHeaderCellDef class="col-end"></th>
                                    <td mat-cell *matCellDef="let element" class="col-end"></td>
                                </ng-container>

                                <ng-container *ngIf="column != 'Alumno' && column != 'end'" matColumnDef="{{column}}">
                                    <th mat-header-cell *matHeaderCellDef class="col-materia"
                                        [matTooltip]="(materias | filtroID:+column).nombre">
                                        <div class="materia-head">
                                            <div class="materia-code">{{ (materias | filtroID:+column).nickName }}</div>
                                            <small class="materia-hours muted">
                                                {{ (materias | filtroID:+column).horasClase }}h |
                                                {{ (materias | filtroID:column).horasEsperadas }}h
                                            </small>
                                        </div>
                                    </th>

                                    <td mat-cell *matCellDef="let element" class="col-materia">
                                        <div class="cell-content" #currMateria
                                            *ngIf="(element.materias | filtroID:+column)">
                                            <ng-container
                                                *ngIf="selectedSection === 1 && (element.materias | filtroID:+column).numerico">
                                                <button type="button" class="pill warn"
                                                    (click)="getDetailsAsistencia(element, column, currMateria)">
                                                    <small>
                                                        {{ viewMode == 'numbers'
                                                        ? (element.materias | filtroID:+column).numerico
                                                        : (element.materias | filtroID:+column).porcentaje + '%' }}
                                                    </small>
                                                </button>
                                            </ng-container>

                                            <ng-container
                                                *ngIf="selectedSection === 2 && (element.materias | filtroID:+column).faltaTareaAcumula">
                                                <button type="button" class="pill warn"
                                                    (click)="getDetailsTarea(element, column, currMateria)">
                                                    <small>{{ (element.materias | filtroID:+column).faltaTareaAcumula
                                                        }}</small>
                                                </button>
                                            </ng-container>
                                        </div>
                                    </td>
                                </ng-container>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </section>

                <ng-template #loading>
                    <div class="loading">
                        <mat-spinner mode="indeterminate"></mat-spinner>
                    </div>
                </ng-template>
            </main>
        </mat-card>
    </mat-drawer-content>
</mat-drawer-container>